import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';

import { action } from 'mobx';
import applicationContext from 'core/utils/applicationContext';
import {MissingDocumentService} from 'application/missing-document/services';
import {resolveColumns} from 'application/facility/util/resolveColumns';

@applicationContext
class MissingDocumentViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const missingDocumentService = new MissingDocumentService(rootStore.application.baasic.apiClient);
        const permissions = rootStore.userStore.user.permissions;
        let actions = {};
        let routes = {};

        if(permissions.importReferenceSection !== undefined && permissions.importReferenceSection.includes("Full")){
            actions = {
                onDelete: (item) => this.deleteResource(item),
                onEdit: async (item) => routes.edit(item),
                actionsWidth: 80
            };
            routes = {
                create: () => rootStore.routerStore.goTo(
                    'master.app.main.missing-document.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i => i.id === item.id,() => item.name);
                    return rootStore.routerStore.goTo(
                        'master.app.main.missing-document.edit',
                        { id: item.id }
                    )
                },
            };
        }

        super(rootStore, {
            name: 'import-reference',
            autoInit: true,
            routes: routes,
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await missingDocumentService.find({
                            ...params, embed:"itemCategory"
                        });

                        response.data.item = response.data.item.map(i => {
                            return {
                                ...i,
                                itemCategory: i.itemCategory && i.itemCategory.name
                            };
                        });

                        return  response.data;
                    },
                    delete: async (item) => {
                        await missingDocumentService.delete(item);
                    }
                }
            },
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'MISSING_DOCUMENT.LIST.COLUMNS.NAME',
                    width: 400
                },
                {
                    key: 'note',
                    title: 'MISSING_DOCUMENT.LIST.COLUMNS.NOTE'
                },
                {
                    key: 'itemCategory',
                    title: 'MISSING_DOCUMENT.LIST.COLUMNS.ITEM_CATEGORY_NAME',
                    width: 200
                },
            ]),
            actions: actions
        }));
    } 

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('MISSING_DOCUMENT.LIST.ACTIONS.SUCCESS_DELETE');
    }

}

export default MissingDocumentViewStore;